import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesRight } from "@fortawesome/free-solid-svg-icons";
const OmanPccUse = () => {
  return (
    <div className="pccImpContainer">
      <h2>
        Common Uses of Oman <span>PCC</span>
      </h2>
      <p>PCC verification holds significant importance for various reasons:</p>
      <ul>
        <li>
          {" "}
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>{" "}
          <span>Visa and Immigration:</span>An Oman PCC is often required for
          visa applications, residency permits, and other immigration-related
          processes to ensure the applicant has no criminal history.
        </li>
        <li>
          {" "}
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>{" "}
          <span>Employment:</span>Employers in Oman may request a PCC to verify
          the qualifications and background of potential employees.
        </li>
        <li>
          {" "}
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>{" "}
          <span> Education:</span> Educational institutions in Oman may require
          a PCC to ensure the safety of their campus and the integrity of their
          student body.
        </li>
        <li>
          {" "}
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>{" "}
          <span>Legal Proceedings:</span> Oman PCCs may be needed for various
          legal processes, such as marriage, adoption, and business
          transactions, to prove the individual's clean criminal record.
        </li>
      </ul>
      <p>
        Oman PCC verification in Bangalore is a critical process for individuals
        planning to live, work, study, or engage in business in Oman. Goodway
        Attestation Services offers expert assistance in navigating the
        complexities of the PCC verification process, ensuring that documents
        are authenticated and accepted by the Omani authorities. With their
        efficient and comprehensive services, individuals can confidently pursue
        their plans in Oman, knowing that their documents are legally recognized
        and compliant with foreign regulations. Whether for immigration,
        education, employment, or legal purposes, Goodway Attestation Services
        is the trusted partner for Oman PCC verification in Bangalore.
      </p>
    </div>
  );
};

export default OmanPccUse;
